import {
  extractUrlFromBackgroundImage,
  normalizeBackgroundImageValue,
} from '../utils/backgroundImageCss';
import { requestOpenBackgroundImagePicker } from './editorBridge';

/**
 * Custom Style Manager field for background-image (blob library instead of base64 file input).
 * GrapesJS 0.20: create() receives { change, updateStyle, ... } — not emit.
 */
export function registerBackgroundImageProperty(editor) {
  const sm = editor?.StyleManager;
  if (!sm || typeof sm.addType !== 'function') return;

  const typeId = 'background-image-picker';
  if (sm.getType && sm.getType(typeId)) return;

  sm.addType(typeId, {
    create({ updateStyle }) {
      const wrap = document.createElement('div');
      wrap.className = 'gjs-field-bg-image-picker';

      const preview = document.createElement('div');
      preview.className = 'gjs-bg-image-preview';
      preview.setAttribute('aria-hidden', 'true');

      const actions = document.createElement('div');
      actions.className = 'gjs-bg-image-actions';

      const chooseBtn = document.createElement('button');
      chooseBtn.type = 'button';
      chooseBtn.className = 'gjs-bg-image-choose-btn';
      chooseBtn.textContent = 'Choose image…';

      const clearBtn = document.createElement('button');
      clearBtn.type = 'button';
      clearBtn.className = 'gjs-bg-image-clear-btn';
      clearBtn.textContent = 'Clear';
      clearBtn.title = 'Remove background image';

      const applyValue = (url) => {
        if (typeof updateStyle !== 'function') return;
        if (!url) {
          updateStyle('', { partial: false });
          return;
        }
        updateStyle(normalizeBackgroundImageValue(url), { partial: false });
      };

      chooseBtn.addEventListener('click', () => {
        const current = extractUrlFromBackgroundImage(wrap.dataset.currentValue || '');
        const opened = requestOpenBackgroundImagePicker(current, applyValue);
        if (!opened) {
          window.alert('Image library is not ready yet. Try again in a moment.');
        }
      });

      clearBtn.addEventListener('click', () => applyValue(''));

      actions.appendChild(chooseBtn);
      actions.appendChild(clearBtn);
      wrap.appendChild(preview);
      wrap.appendChild(actions);
      return wrap;
    },
    update({ value, el }) {
      const url = extractUrlFromBackgroundImage(value);
      el.dataset.currentValue = value || '';
      const preview = el.querySelector('.gjs-bg-image-preview');
      if (preview) {
        if (url) {
          preview.style.backgroundImage = `url("${url.replace(/"/g, '\\"')}")`;
          preview.classList.add('gjs-bg-image-preview--has-image');
        } else {
          preview.style.backgroundImage = '';
          preview.classList.remove('gjs-bg-image-preview--has-image');
        }
      }
    },
  });
}
